import { render, staticRenderFns } from "./FacebookPage.vue?vue&type=template&id=3b0f0edc&scoped=true&"
import script from "./FacebookPage.vue?vue&type=script&lang=ts&"
export * from "./FacebookPage.vue?vue&type=script&lang=ts&"
import style0 from "./FacebookPage.vue?vue&type=style&index=0&id=3b0f0edc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0f0edc",
  null
  
)

export default component.exports